import { createContext } from 'react';

export interface PermissionsContextValue {
  isAllowed: boolean;
  isLoading: boolean;
  tooltipText: string;
  deniedPermissions: string[];
}

export const DEFAULT_TOOLTIP_TEXT = "You don't have the required permissions";

export const defaultPermissionsContextValue: PermissionsContextValue = {
  isAllowed: true,
  isLoading: false,
  tooltipText: DEFAULT_TOOLTIP_TEXT,
  deniedPermissions: [],
};

/**
 * Context that broadcasts the resolved permission state to descendant form components.
 * When no PermissionsProvider is present, the default value leaves components unaffected
 * (isAllowed: true).
 * @internal
 */
export const PermissionsContext = createContext<PermissionsContextValue>(
  defaultPermissionsContextValue,
);
